import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import SliderIcon from 'containers/InsightPage/sections/ArticleSlider/SliderIcon';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const ArticleSliderWrapper = styled.div`
  /* margin-top: 64px; */
  margin-bottom: 64px;
  grid-column: 2/ -2;

  ${mediaDesktop(css`
    margin-bottom: 96px;
    grid-column: 3/ -3;
  `)}
`;

const Flex = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InnerContent = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Figure = styled(motion.figure)`
  cursor: grab;
  user-select: none;
`;

export const ImageWrapper = styled(motion.div)`
  width: 100%;
  aspect-ratio: 16/9;
  display: flex;
`;

export const Image = styled(motion.img)`
  display: block;
  width: 100%;
  min-width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  transition: transform 0.3s;
`;

export const CaptionWrapper = styled.figcaption`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;

export const ControlsWrapper = styled.div`
  padding-top: 12px;
  ${Flex}

  ${mediaDesktop(css`
    padding-top: 24px;
  `)}
`;

export const ImageCounter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${mediaDesktop(css`
    flex-direction: row;
  `)}
`;

export const Controls = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  justify-content: space-between;
  padding: 0 16px;
  width: 100%;
  display: none;
  z-index: 9;

  ${mediaDesktop(css`
    display: flex;
  `)}
`;

export const Svg = styled(SliderIcon)`
  width: 56px;
  height: 56px;
  cursor: pointer;

  &:nth-child(2) {
    transform: rotate(180deg);
  }

  &:hover {
    circle {
      fill-opacity: 1;
    }

    rect {
      fill: ${colors.lighterMineShaft};
    }
  }
`;

export const TextWrapper = styled.div`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}

  ${mediaDesktop(css`
    width: 13vw;
  `)}
`;
